import { getApiBaseUrl } from '../config/apiBaseUrl';

export type PhotoMediaSize = 'thumb' | 'preview' | 'full';

export interface PhotoViewerItem {
  id?: string;
  url?: string;
  s3Key?: string;
}

export function appendSizeToMediaUrl(url: string, size: PhotoMediaSize): string {
  if (size === 'full' || !url.includes('/storage/media?')) {
    return url;
  }
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('size', size);
    return parsed.toString();
  } catch {
    return url;
  }
}

/** URL locale immédiate pendant l'upload (Object URL). */
export function createLocalPreviewUrl(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function revokeLocalPreviewUrl(url: string): void {
  if (url.startsWith('blob:')) {
    URL.revokeObjectURL(url);
  }
}

export function buildPhotoViewerItemsFromObjet(
  objet: { photos?: Array<{ id?: string; url?: string; s3Key?: string }> },
): PhotoViewerItem[] {
  return (objet.photos ?? [])
    .map((photo) => ({
      id: photo.id,
      url: photo.url,
      s3Key: photo.s3Key,
    }))
    .filter((p) => p.url || p.s3Key);
}

export function apiPhotosUrl(objetId: string, size: PhotoMediaSize = 'full'): string {
  const params = new URLSearchParams({ size });
  return `${getApiBaseUrl()}/objets/${objetId}/photos?${params.toString()}`;
}
